import React,{Component} from 'react';
import {connect} from 'react-redux'
import {createcopyProject} from '../../store/actions/projectcopyActions'
import img4 from '../../assets/p10.png'

class CreatecopyProject extends Component{
    state={
        title: '',
        content:'',
        imageurl:''
  
    }
    handleChange = (e) =>{
        this.setState({
            [e.target.id]: e.target.value

        })
    }
    handleSubmit = (e) =>{
        e.preventDefault();
        this.props.createcopyProject(this.state)
    }
    render(){
        return(
            <div className="container">
                <form onSubmit={this.handleSubmit} className="white">
                    <h5 className="grey-text text-darken-3">Create Account</h5>
                    <div className="input-field">
                        <label htmlFor="title">Name</label>
                        <input type="text" id="title" onChange={this.handleChange}/>
                    </div>
                    <div className="input-field">
                        <label htmlFor="content">Mention your role(President,Vice President Core Member etc)</label>
                        <textarea id="content" className="materialize-textarea" onChange={this.handleChange}></textarea>
                    </div>
                    <div className="input-field">
                        <label htmlFor="imageurl">Image URL Code only GOOGLE DRIVE ONLY (Please upload the code)</label>
                        <input id="imageurl" type="text" onChange={this.handleChange} />
                    </div>
                    <img src={img4}></img>
                    <h4>Please dont submit more then Once</h4>
                    <div className="input-field">
                        <button onClick={() => (alert("Registered Successfully Go to Our Team And Check Out"))} className ="btn pink lighten-1 z-depth-0" to='/members'>
                            Submit
                        </button>
                    </div>
                </form>

            </div>
        )
    }
}
const mapDispatchToProps = (dispatch) => {
    return{
        createcopyProject: (projectcopy) => dispatch(createcopyProject(projectcopy))
    
    }
}

export default connect(null,mapDispatchToProps)(CreatecopyProject);